import moment from 'moment';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  searchText: null,
  statusOptions: [
    {
      id: 'TODAS',
      description: 'Todas',
      value: null,
    },
    {
      id: 'PENDENTES',
      description: 'Pendentes',
      value: () => '(situacaoEntrega = \'PENDENTE\')',
    },
    {
      id: 'ATRASADAS',
      description: 'Atrasadas',
      value: () => `(situacaoEntrega = 'PENDENTE' and dataPrevisaoEntrega < ${moment().format('YYYY-MM-DD')})`,
    },
    {
      id: 'RECEBIDAS',
      description: 'Recebidas',
      value: () => '(situacaoEntrega = \'RECEBIDA\')',
    },
  ],
  selectedStatus: {
    id: 'PENDENTES',
    description: 'Pendentes',
    value: () => '(situacaoEntrega = \'PENDENTE\')',
  },
  empresa: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  dataInicial: null,
  dataFinal: null,
  grupo: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
